// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"522": "6f55264f","7869": "22f405b2","9339": "79c581cf",}[chunkId] + ".css"
}